import React from 'react'
import { css } from '@emotion/react'
import { Skeleton, Separator } from '@fs/zion-ui'

const containerCss = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 0;
`

const promoContainer = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;

  & > div {
    margin-top: 0;
    margin-inline-end: 23px;
    margin-bottom: 20px;
    margin-inline-start: 23px;
  }
`

export default function PromoSkeleton(): JSX.Element {
  return (
    <div css={containerCss} data-testid="page-skeleton">
      <Skeleton.Image height={400} />
      <Separator size="xl" />
      <Skeleton.H2 maxWidth={500} />
      <Separator size="xl" />
      <div css={promoContainer}>
        {Array.from({ length: 3 }).map((_, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={i}>
            <Skeleton.Image width={310} height={229} />
            <Skeleton.H3 />
            <Skeleton.Paragraph lineCount={4} size="md" />
            <Skeleton.Button />
          </div>
        ))}
      </div>
      <Separator size="xl" />
    </div>
  )
}
